import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

import Block from '../../../../../components/Block';
import Column from '../../../../../components/Column';

import CampaignActionCard from '../Card/CampaignActionCard';
import CampaignMetaOverviewCard from '../Card/CampaignMetaOverviewCard';
import CampaignModificationOverviewCard from '../Card/CampaignModificationOverviewCard';
import CampaignOverviewCard from '../Card/CampaignOverviewCard';
import CampaignPlatformOverviewCard from '../Card/CampaignPlatformOverviewCard';
import CampaignSummaryCard from '../Card/CampaignSummaryCard';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import { useUserContext } from '../../../../../hooks/Contexts/UserContext';

const CampaignPageOverviewPageTab = () => {
    const { userContext } = useUserContext();
    const { campaign } = useCampaignPageContext();

    return (
        <Box>
            <Block>
                <CampaignSummaryCard campaign={campaign} />
            </Block>

            <Block>
                <Grid container spacing={4}>
                    <Grid size={{ xs: 8 }}>
                        <Column>
                            <CampaignOverviewCard campaign={campaign} />
                        </Column>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <Column>
                            <CampaignActionCard campaign={campaign} />

                            {(userContext.isAdmin() || userContext.isOpsAdmin()) && (
                                <CampaignPlatformOverviewCard campaign={campaign} />
                            )}

                            <CampaignModificationOverviewCard campaign={campaign} />

                            <CampaignMetaOverviewCard campaign={campaign} />
                        </Column>
                    </Grid>
                </Grid>
            </Block>
        </Box>
    );
};

export default CampaignPageOverviewPageTab;
